const _ = require('lodash');

function pageUpdateAnalytics(state) {
    // update analytics Page Id
    if (state.getAnalytics) {
        const analyticsPageId = state.getAnalytics();
        // set the analyticsPageId to the window object so that it can be accessed by AEM components
        window.analyticsPageId = analyticsPageId;
        if (analyticsPageId) {
            return analyticsPageId;
        }
    }
}

function atmGlobalContextService($window, $state, currentUserService, storePickerService, settingsService, $rootScope, anonymousUserIdService) {
    this.$window = $window;
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.user = currentUserService.get();
    this.storePicker = storePickerService;
    this.currentPageName = null;
    this.previousPageName = null;
    this.anonymousUserIdService = anonymousUserIdService;
    settingsService.getSettingValue('BazaarVoice', 'EncryptionKeyId').then((value) => {
        this.bazaarVoiceEncryptionKeyId = value;
    });

    // Keep track of the previous page
    this.$rootScope.$on('$viewContentLoading', () => {
        this.previousPageName = this.currentPageName;
        this.currentPageName = pageUpdateAnalytics(this.$state);
    });
}

function boolToAnalytics(value) {
    return value ? 'true' : 'false';
}

function convertYearTo4Digits(inputString) {
    // Match last 2 or 4 digits in the string
    const match = inputString.match(/(\d{2}|\d{4})$/);
    if (match) {
        const year = match[0];

        // If the year is already 4 digits, return the original string
        if (year.length === 4) {
            return inputString;
        }
        // Convert 2-digit year to 4 digits
        const fullYear = parseInt(year) <= 69 ? '20' + year : '19' + year;
        // Replace the year in the original string with the 4-digit version
        return inputString.replace(/\d{2}$/, fullYear);
    }
    // Return the original string if no match is found
    return inputString;
}

atmGlobalContextService.prototype.getGlobalContext = function () {
    const gContext = {};

    const filteredStateParams = _.omit(this.$state.params, ['email', 'password', 'phone', 'phoneMasked']);

    // Update page infos
    gContext.pageInfo = {
        id: pageUpdateAnalytics(this.$state),
        fullUrl: this.$window.location.href,
        referringUrl: this.$window.location.origin,
        stateParams: filteredStateParams,
        previousPageName: this.previousPageName
    };

    // Update user infos
    gContext.user = {};
    const isGuest = this.user.isGuest;

    if (!isGuest) {
        gContext.user = {
            id: this.user.id,
            hasEdrCard: boolToAnalytics(this.user.hasEdrCard),
            edrNumber: this.user.edrNumber,
            orderCount: this.user.orderCount,
            isStaffMember: boolToAnalytics(this.user.isStaffMember),
            email: this.user.encodedEmail,
            encryptedEmail: this.user.encryptedEmail,
            encryptionKeyId: this.bazaarVoiceEncryptionKeyId,
            promoteIQID: this.anonymousUserIdService.getAnonymousId(),
            applePayEnabled: window.ApplePaySession && !!window.ApplePaySession.canMakePayments() ? 'yes' : 'no',
            yob: this.user.dateOfBirth && this.user.dateOfBirth.length >= 8 ? convertYearTo4Digits(this.user.dateOfBirth.split('/')[2]) : null,
            currentYear: new Date().getFullYear()
        };
    } else {
        gContext.user.applePayEnabled = 'no';
    }
    gContext.user.isGuest = boolToAnalytics(isGuest);

    // store infos
    if (this.storePicker.store) {
        gContext.user.storeName = this.storePicker.store.AddressSuburb;
        gContext.user.storeId = this.storePicker.store.FulfilmentStoreID;
        gContext.user.fullfillmentType = this.storePicker.fulfilmentMethod;
        gContext.user.promoteIQID = this.anonymousUserIdService.getAnonymousId();
    }

    return gContext;
};

module.exports = atmGlobalContextService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/atm-global-context-service.js
 **/